import { useQueryChecker } from 'core/hooks';
import { ShipTimeStatus } from 'inventory/enums';
import { inventoryService } from 'inventory/services';
import { IShipTime, IShipTimePayload } from 'inventory/types';

export const useGetShipTime = (
  requestPayload: IShipTimePayload,
  enabled = false,
  onSuccess: (data: IShipTime) => void,
  onError: (data: IShipTime) => void
) => {
  useQueryChecker<IShipTime>({
    fetchData: inventoryService.getShipTimeStatus,
    queryKey: 'getShipTimeStatus',
    requestPayload,
    enabled,
    isFetchDataFinished: (data: IShipTime) => data?.message === ShipTimeStatus.FINISHED,
    onSuccess,
    onError,
  });
};
